import { TPeopleDetails } from "../../hooks/useCustomerPeopleDetails";

import styles from "./businessOwnersList.module.scss";

interface IBusinessOwnersList {
  setSelectedBusinessOwner?: any;
  list: TPeopleDetails[];
}

const BusinessOwnersList = ({
  list,
  setSelectedBusinessOwner,
}: IBusinessOwnersList) => {
  const getInitials = (_item: TPeopleDetails) => {
    const firstName = _item?.first_name || _item?.firstname || "";
    const lastName = _item?.last_name || _item?.lastname || "";

    const firstInitial = firstName.charAt(0).toUpperCase();
    const lastInitial = lastName.charAt(0).toUpperCase();

    return `${firstInitial}${lastInitial}`;
  };

  return (
    <div className={styles.BusinessOwners}>
      {list.map((_item) => (
        <div
          className={styles.BusinessOwner}
          key={_item.id}
          onClick={() =>
            setSelectedBusinessOwner && setSelectedBusinessOwner(_item)
          }
        >
          <span className={styles.Initials}>{getInitials(_item)}</span>
        </div>
      ))}
    </div>
  );
};

export default BusinessOwnersList;
